import { render, staticRenderFns } from "./proxy.vue?vue&type=template&id=5652c980&scoped=true&"
import script from "./proxy.vue?vue&type=script&lang=js&"
export * from "./proxy.vue?vue&type=script&lang=js&"
import style0 from "./proxy.vue?vue&type=style&index=0&id=5652c980&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5652c980",
  null
  
)

export default component.exports